import { z } from 'zod';

/**
 * Mirrors the server's `acceptInviteBodySchema`. The floor is higher than a student's because
 * these accounts can move money and read every user's data.
 */
export const acceptInviteFormSchema = z
  .object({
    password: z
      .string()
      .min(12, 'Use at least 12 characters')
      .max(128, 'That password is too long')
      .refine((value) => /[a-z]/.test(value), 'Include a lowercase letter')
      .refine((value) => /[A-Z]/.test(value), 'Include an uppercase letter')
      .refine((value) => /[0-9]/.test(value), 'Include a number'),
    confirm: z.string(),
  })
  .refine((values) => values.password === values.confirm, {
    message: 'Both passwords must match',
    path: ['confirm'],
  });

export type AcceptInviteForm = z.infer<typeof acceptInviteFormSchema>;
